import { useEffect } from "react";

/**
 * Per-route SEO: sets <title>, meta description, canonical, and Open Graph tags.
 * Enhances base tags from index.html on client-side navigation.
 */
export default function SEO({ title, description }) {
  useEffect(() => {
    const baseTitle = "Doudou Alert";
    const finalTitle = title ? `${title} · ${baseTitle}` : `${baseTitle} · Retrouvez le doudou perdu de votre enfant`;
    document.title = finalTitle;

    const url = typeof window !== "undefined" ? window.location.href : "";

    // helper: upsert <meta name="..." content="..."> or property="..."
    const setMeta = (key, value, attr = "name") => {
      if (!value) return;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };
    const setLink = (rel, href) => {
      if (!href) return;
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    if (description) setMeta("description", description);
    setMeta("og:title", finalTitle, "property");
    if (description) setMeta("og:description", description, "property");
    if (url) setMeta("og:url", url, "property");
    setMeta("twitter:title", finalTitle);
    if (description) setMeta("twitter:description", description);
    if (url) setLink("canonical", url);
  }, [title, description]);
  return null;
}
